module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ../js/~/babel-runtime/~/core-js/library/modules/_is-object.js
// module id = 32
// module chunks = 0